import {useEffect,useRef} from 'react';
import './hero-banner.css';

const desktopImage='https://media-manager-c.questera.ai/greta-media/048a294ccd6718892c549bd7b643fcf120d7d84b38289b7b4b78889b4f78a748e8c921a45f072a6a0302366ee1557436/images/aW1hZ2UvanBlZw==/49278ee0d136b06c4ae64b818b15b7ae.jpg';
const tabletImage='https://media-manager-c.questera.ai/greta-media/048a294ccd6718892c549bd7b643fcf120d7d84b38289b7b4b78889b4f78a748e8c921a45f072a6a0302366ee1557436/images/aW1hZ2UvanBlZw==/1744d0cbe178453a0dd317903f5cafb1.jpg';
const phoneImage='https://media-manager-c.questera.ai/greta-media/048a294ccd6718892c549bd7b643fcf120d7d84b38289b7b4b78889b4f78a748e8c921a45f072a6a0302366ee1557436/images/aW1hZ2UvanBlZw==/d1d36740320309b531b2e4f0bf228b71.jpg';

function publishRatio(image) {
  if (!image || !image.naturalWidth || !image.naturalHeight) return;
  const ratio=image.naturalWidth / image.naturalHeight;
  document.documentElement.style.setProperty('--hero-banner-ratio',ratio.toFixed(4));
}

export default function HeroScene() {
  const imageRef=useRef(null);

  useEffect(()=> {
    if (imageRef.current && imageRef.current.complete) {
      publishRatio(imageRef.current);
    }
  },[]);

  return (
    <div className="hero-banner" aria-hidden="true">
      <picture>
        <source media="(max-width: 800px)" srcSet={phoneImage} />
        <source media="(max-width: 1180px)" srcSet={tabletImage} />
        <img
          ref={imageRef}
          src={desktopImage}
          alt=""
          fetchpriority="high"
          onLoad={(event)=> publishRatio(event.currentTarget)}
        />
      </picture>
    </div>
  );
}